<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'detailsRegister',
    components: {
      baseEdit,
    },
  };
</script>
